export const creationUsersBatchFinish = {
  header: 'Users Batch Creation',
  body: 'You Request is under process and Users are being created Right now.',
  confirmText: 'Finish',
}

export const changePasswordModalData = {
  header: 'Change password',
  body: 'Are you sure you want to change your password ?',
  subBody: 'Once Confirmed, You can’t undo this action anymore.',
  cancelText: 'back',
  confirmText: 'Yes, Change',
  message: 'Your Password has been Changed successfully',
}

export const addRequestDocumentFinish = {
  header: 'Document Request',
  body: 'Your Request has been sent successfully',
  confirmText: 'Finish',
}

export const approveNotificationRequestFinish = {
  header: 'Approve a Request',
  body: 'Your Actions are being processed',
  confirmText: 'Close',
  ApproveText: 'Yes, Approve',

}
export const rejectNotificationRequestFinish = {
  header: 'Reject a Request',
  body: 'Your Actions are being processed',
  confirmText: 'Close',
  ApproveText: 'Yes, Reject',

}

export const approveNotificationsSelectedRequestFinish = {
  header: 'Approve Selected Requests',
  body: 'Your Actions are being processed',
  confirmText: 'Close',
  ApproveText: 'Yes, Approve',

}

export const rejectNotificationsSelectedRequestFinish = {
  header: 'Reject Selected Requests',
  body: 'Your Actions are being processed',
  confirmText: 'Close',
  ApproveText: 'Yes, Reject',
}

export const selectApproveFinishModalData = {
  header: 'Approve a Request',
  body: 'Your Action is being Processed',
  confirmText: 'Finish',
}
export const selectRejectFinishModalData = {
  header: 'Reject a Request',
  body: 'Your Action is being Processed',
  confirmText: 'Finish',
}

export const importUsersRolesFinish = {
  header: 'Import User\'s Roles',
  body: 'Your import is under process and users roles are being updated Right now.',
  confirmText: 'Finish',
}
